<template>
  <span
    v-show="active"
    class="icon is-small has-text-primary"
  >
    <font-awesome-icon :icon="upOrDown" />
  </span>
</template>

<script>
export default {
  props: {
    active: Boolean,
    direction: {
      type: String,
      default: 'asc',
    },
  },
  computed: {
    upOrDown() {
      if (this.direction === 'asc') {
        return 'chevron-down';
      }
      return 'chevron-up';
    },
  },
};
</script>
